import client from "../../../shared/api/client";

// Typeahead against the team-scoped Spotify search endpoint. Returns the shaped
// rows: { spotify_id, name, image, followers, popularity, genres, external_url,
// linked_artist }. Callers debounce; this is a thin GET.
export const searchSpotifyArtists = (teamId, q) =>
  client.get(`/teams/${teamId}/spotify_artists`, { params: { q } }).then(({ data }) => data);
